module.exports = __webpack_public_path__ + "media/EmployeeTransitionInformationVideo.08308baa.mp4";